<div
  [formGroup]="commissionTableForm"
  fxLayout="column"
  fxLayoutGap="15px"
>

  <h2>
    Edycja tabeli prowizyjnej
    {{ commissionTable.shortName }}
  </h2>

  <mat-card>

    <div fxLayout="row" fxLayoutGap="15px">

      <mat-form-field fxFlex="70">
        <mat-label>Nazwa</mat-label>

        <input
          matInput
          formControlName="name"
          required
        >

        <mat-error
          *ngIf="nameControl.hasError('backendError')"
        >
          {{ nameControl.getError('backendError') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <mat-label>Nazwa skrócona</mat-label>

        <input
          matInput
          formControlName="shortName"
          required
        >

        <mat-error
          *ngIf="shortNameControl.hasError('backendError')"
        >
          {{ shortNameControl.getError('backendError') }}
        </mat-error>
      </mat-form-field>

    </div>

    <div fxLayout="row" fxLayoutGap="15px">

      <app-datepicker
        fxFlex="50"
        label="Obowiązuje od"
        [required]="true"
        [control]="validFromControl"
      ></app-datepicker>

      <app-datepicker
        fxFlex="50"
        label="Obowiązuje do"
        [required]="false"
        [control]="validToControl"
        [minDate]="validFromControl.value"
      ></app-datepicker>

    </div>

    <div
      fxLayout="row"
      *ngIf="commissionTable.sourceTable"
    >
      <app-detail
        fxFlex="100"
        header="Tabela źródłowa"
        [value]="
          commissionTable.sourceTable.shortName
          + ' - '
          + commissionTable.sourceTable.name
        "
      ></app-detail>
    </div>

  </mat-card>

  <mat-card>

    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <h3>Przypisania</h3>

      <button
        type="button"
        (click)="addAssignment()"
        mat-stroked-button
        color="accent"
      >
        <mat-icon>add</mat-icon>
        Dodaj przypisanie
      </button>
    </div>

    <div
      formArrayName="assignments"
      fxLayout="column"
      fxLayoutGap="10px"
    >

      <div
        *ngFor="
          let assignment of assignments.controls;
          index as i
        "
        [formGroupName]="i"
        fxLayout="row"
        fxLayoutGap="15px"
        fxLayoutAlign="start center"
      >

        <app-dict
          fxFlex
          label="Firma"
          dictType="company"
          [required]="true"
          [control]="$any(assignment.get('company'))"
        ></app-dict>

        <app-dict
          fxFlex
          label="Rodzaj umowy Partnera"
          dictType="contract_type"
          [required]="true"
          [control]="$any(assignment.get('contractType'))"
        ></app-dict>

        <button
          type="button"
          mat-icon-button
          color="warn"
          [disabled]="assignments.length === 1"
          (click)="removeAssignment(i)"
        >
          <mat-icon>delete</mat-icon>
        </button>

      </div>

    </div>

    <mat-error
      *ngIf="
        commissionTableForm
          .get('assignments')
          .hasError('backendError')
      "
    >
      {{
        commissionTableForm
          .get('assignments')
          .getError('backendError')
      }}
    </mat-error>

  </mat-card>

  <div
    fxLayout="row"
    fxLayoutGap="15px"
  >

    <button
      (click)="save()"
      [class.spinner]="processingRequest"
      [disabled]="
        processingRequest
        || !commissionTableForm.valid
      "
      mat-stroked-button
      color="primary"
    >
      <mat-icon>save</mat-icon>
      <span> Zapisz</span>
    </button>

    <button
      (click)="closeDialog()"
      mat-stroked-button
      color="warn"
    >
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span>
    </button>

  </div>

</div>
